import { render, staticRenderFns } from "./ContactRelationshipSelect.vue?vue&type=template&id=194fa34c"
import script from "./ContactRelationshipSelect.vue?vue&type=script&lang=js"
export * from "./ContactRelationshipSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports